module.exports = __webpack_public_path__ + "img/32.fa9b0ca3.jpg";